

export default {
  props: {
    to: {
      type: String,
      required: true
    }
  },
  methods: {
    openInNewTab(url) {
      if(process.client) {
        window.open(url, '_blank', 'noreferrer')
      }
    }
  }
}

